import { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const failed = Boolean(location.state?.error);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (res.ok) {
          const user = await res.json();
          navigate("/anfragen", { state: { user }, replace: true });
        }
      } catch {
        /* nicht angemeldet – Login anzeigen */
      }
    };
    check();
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/anfragen";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen flex-col bg-ink text-white" data-testid="login-page">
      <main className="flex flex-1 items-center justify-center px-5 py-24">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-md rounded-2xl border border-white/10 bg-surface p-8 md:p-10"
        >
          <img
            src="/assets/terbeck-logo.jpeg"
            alt="Terbeck Service GbR Logo"
            className="h-14 w-14 rounded-xl object-cover ring-1 ring-white/15"
          />
          <h1 className="mt-6 font-display text-2xl md:text-3xl font-bold uppercase tracking-tight">
            Interner Bereich
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-white/55">
            Anmeldung für das Team der Terbeck Service GbR – hier finden Sie die eingegangenen
            Website-Anfragen.
          </p>
          {failed && (
            <p data-testid="login-error" className="mt-4 rounded-xl border border-red-500/40 bg-red-500/10 px-4 py-3 text-xs font-semibold text-red-300">
              Anmeldung fehlgeschlagen oder dieses Google-Konto ist nicht freigeschaltet.
            </p>
          )}
          <button
            data-testid="google-login-button"
            onClick={login}
            className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-white py-4 text-sm font-bold tracking-wider text-black transition-colors duration-300 hover:bg-brand-bright"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            MIT GOOGLE ANMELDEN
          </button>
          <Link
            data-testid="login-back-link"
            to="/"
            className="mt-6 inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-brand-bright hover:text-white transition-colors duration-300"
          >
            <ArrowLeft className="h-4 w-4" /> ZURÜCK ZUR STARTSEITE
          </Link>
        </motion.div>
      </main>
    </div>
  );
}
